
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

//Api
import dashboard_api from '../../../api/dashboard_api';
import setup_api from '../../../api/setup_api';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Componentes
import FichaGerador from '../../../views/Cadastros/Geradores/FichaGerador';
import FiltroPrefeitura from '../../../views/Shared/FiltroPrefeitura';
import Loading from 'components/Loading/Loading';
import MainCard from 'components/MainCard/MainCard';
import TabelaListagem from 'components/TabelaListagem/TabelaListagem';

//Helpers
import mascaras from '../../../helpers/mascaras';
import { showMessage } from '../../../helpers/message';

//Context
import { useAuth } from '../../../context/auth';

function GeradoresContratos() {
    const { session, setupVariavel } = useAuth();
    const [titleTable, setTitleTable] = useState("");

    //Cabeçalhos da tabela de listagem de geradores
    const [headersTabela, setHeadersTabela] = useState([
        { value: "Fantasia", objectValue: "fantasia", align: "left", },
        { value: "Razão Social", objectValue: "razao", align: "left" },
        { value: "CPF / CNPJ", objectValue: "cpfcnpj", align: "left" },
        { value: "Endereço", objectValue: "endereco", align: "left", options: { display: false } },
        { value: "Status", objectValue: "status", align: "left" },
        { value: "Categoria", objectValue: "categoria", align: "left" },
        { value: "Ramo de atividade", objectValue: "ramoDeAtividade", align: "left" },
        { value: "Característica", objectValue: "caracteristica", align: "left" },
        { value: "CNAE", objectValue: "cnaes", align: "left" }
    ]);

    //Variavel para navegação entre telas
    const navigate = useNavigate();

    //Variavel para pegar os dados enviados na navegação para saber se tem filtro por contratos firmados
    const location = useLocation();

    //Estado que guarda o id da prefeitura selecionada no select das prefeituras no ambiente privado ou da prefeitura default no ambiente público
    const [prefeitura_Id, setPrefeitura_Id] = useState(null);
    const handlePrefeitura = (value) => {
        setPrefeitura_Id(value);
        loadGeradores(value);
    }

    //Estado que gurada a lista de geradores
    const [geradores, setGeradores] = useState([]);

    useEffect(() => {
        setTitleTable(location.state.option && location.state.option ? location.state.option : "");
        if (session && session?.acesso) {
            if (location.state && location.state.option && location.state.option == "Contrato Pendente" && session.acesso.sigla != "TR")
                setHeadersTabela([
                    { value: "Fantasia", objectValue: "fantasia", align: "left", },
                    { value: "Razão Social", objectValue: "razao", align: "left" },
                    { value: "CPF / CNPJ", objectValue: "cpfcnpj", align: "left" },
                    { value: "Status", objectValue: "status", align: "left" },
                    { value: "Modalidade de Coleta", objectValue: "modalidadeColeta", align: "left" },
                    { value: "Transportador", objectValue: "transportador", align: "left" },
                    { value: "Validade do Cadastro", objectValue: "validadeCadastro", align: "left" },
                    { value: "Motivo", objectValue: "motivoContratoPendente", align: "left", options: { filter: true, filterType: 'textField' } },
                    { value: "CNAE", objectValue: "cnaes", align: "left" }
                ]);
            if (location.state && location.state.option && location.state.option != "Contrato Pendente" && session.acesso.sigla != "TR")
                setHeadersTabela([...headersTabela, { value: "Contratos", objectValue: "contratos", align: "left" }]);

            if (location.state && location.state.option && ["contratos a vencer", "contratos vencidos"].includes(location.state.option) && session.acesso.sigla == "TR") {
                setTitleTable(`com ${location.state.option}`)
                setHeadersTabela([
                    { value: "Fantasia", objectValue: "fantasia", align: "left", },
                    { value: "CPF / CNPJ", objectValue: "cpfcnpj", align: "left" },
                    { value: "Endereço", objectValue: "endereco", align: "left" },
                    { value: "Modalidade de Coleta", objectValue: "modalidadeColeta", align: "left" },
                    { value: "Status", objectValue: "status", align: "left" },
                    { value: "Data Vencimento", objectValue: "validadeCadastro", align: "left" }
                ]);
            }
        }
    }, [session, location.state]);

    //Estado de controle para exibição da tela de ficha do gerador
    const [ficha, setFicha] = useState(false);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Carrega os geradores para serem mostrados na tabela
    const loadGeradores = (prefeitura_id) => {
        setLoading(true);
        dashboard_api.GeradoresContratos(prefeitura_id, location.state && location.state.option ? location.state.option : null)
            .then(response => {
                response.data = response.data.map(gerador => {
                    gerador.cpfcnpj = mascaras.cpfcnpjMask(gerador.cpfcnpj);
                    gerador.cnaes = Array.isArray(gerador.cnaes)
                        ? gerador.cnaes.map(c => c.codigo + (c.principal ? " (Principal)" : "")).join(", ")
                        : gerador.cnaes;
                    return gerador;
                })
                setGeradores(response.data);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));
    }

    //Variavel que guarda as ações da tabela
    const actions = [actionsTable.visualizar((item) => setFicha(item.id))];

    //Controle da exibição da tela de ficha
    if (ficha) {
        return <FichaGerador
            btnVoltar={() => {
                loadGeradores(prefeitura_Id);
                setFicha(false);
            }}
            integracaoCadastros={setupVariavel?.integracaoCadastros}
            permissao={session?.acesso?.sigla == "TR" ? "Editar" : ""}
            id={ficha}
        />
    }

    return (
        <>
            {loading && <Loading />}
            <MainCard
                title={"Geradores " + titleTable.toLowerCase()}
                btnVoltarInTop={() => navigate(-1)}
                noCard
            >
                <div className={`w-100 `}>
                    <div className='mt-4'>
                        <FiltroPrefeitura handleValue={handlePrefeitura} />
                        <TabelaListagem
                            headers={headersTabela}
                            items={geradores}
                            actions={actions}
                            title="Lista de geradores"
                            options={{ print: false, search: true, pagination: true }}
                        />
                    </div>
                </div>
            </MainCard >
        </>
    )
}

export default GeradoresContratos;